import { PASSWORD_RULE_ORDER, type PasswordRuleName } from './validatePassword';

export type PasswordRulesTranslateFn = (key: string, options?: Record<string, string | number>) => string;

const PASSWORD_RULE_LABEL_KEYS: Record<(typeof PASSWORD_RULE_ORDER)[number], string> = {
  min_length: 'ns.common:password_criteria:min_length',
  uppercase: 'ns.common:password_criteria:upper_case',
  numbers: 'ns.common:password_criteria:numbers',
  special: 'ns.common:password_criteria:special',
  lowercase: 'ns.common:password_criteria:lower_case',
};

/**
 * Checklist labels for password criteria rows, in {@link PASSWORD_RULE_ORDER}.
 */
export const passwordRules = (t: PasswordRulesTranslateFn): Record<string, string> => {
  return PASSWORD_RULE_ORDER.reduce<Record<string, string>>((acc, ruleName: PasswordRuleName) => {
    acc[ruleName] = t(PASSWORD_RULE_LABEL_KEYS[ruleName]);
    return acc;
  }, {});
};
